// GoogleMiniMap.tsx
import React from 'react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';

interface MiniMapProps {
  lat: number;
  lng: number;
  height?: number | string; // default 400
  zoom?: number; // default 14
  linkUrl: string;
}

export const GoogleMiniMap: React.FC<MiniMapProps> = ({ lat, lng, height = 400, zoom = 14, linkUrl }) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script', // ensures single script tag
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_KEY as string,
  });

  if (!isLoaded) {
    // fallback skeleton while SDK loads (optional)
    return <div style={{ width: '100%', height }} />;
  }

  return (
    <GoogleMap
      mapContainerStyle={{ width: '100%', height }}
      center={{ lat, lng }}
      zoom={zoom}
      options={{ disableDefaultUI: true, draggableCursor: 'pointer' }}
      onClick={() => window.open(linkUrl, '_blank', 'noopener')}
    >
      <Marker position={{ lat, lng }} />
    </GoogleMap>
  );
};
